import { Dialog, DialogContent, DialogActions, Typography, Stack } from '@mui/material';
import { ContainedButton } from '../../../../components/Button';

interface Props {
  open: boolean;
  onClose: () => void;
  onProceed: () => void;
}

export const CameraInstructionsDialog = ({ open, onClose, onProceed }: Props) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogContent>
        <Stack spacing={2} py={2}>
          <Typography variant="h6" fontWeight="bold">
            Tips for capturing your test strip
          </Typography>
          <Typography>
            • Place the test strip on a white background
          </Typography>
          <Typography>
            • Ensure good lighting conditions
          </Typography>
          <Typography>
            • Position the strip within the frame
          </Typography>
          <Typography>
            • Keep the camera steady
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <ContainedButton onClick={onProceed} fullWidth>
          Got it
        </ContainedButton>
      </DialogActions>
    </Dialog>
  );
}; 